import { Grid2, Modal, styled } from "@mui/material";

export const Styled = {
    Modal: styled(Modal)`
        display: flex;
        align-items: center;
        justify-content: center;
    `,
    Container: styled(Grid2)`
        background-color: white;
        padding: 30px 35px;
        max-width: 500px;
        border-radius: 8px;
    `,
};
